// hooks/useSessionTracker.js
import { useEffect, useRef } from 'react';
import { DASHBOARD_TILES_CLICK_STATS } from './constants/Endpoints';
import { API } from './config/AppConfig';
import { replaceRoute } from './utils/common.utils';

export default function useSessionTracker(
  handleperiodicSave = () => { console.log("Default Repeating"); },
  period = 3600000, 
  handlefinalSave = () => { console.log("Default Final Save"); } ) {

    const intervalRef = useRef(null);    

    useEffect(() => {
      // Start interval
      intervalRef.current = setInterval(handleperiodicSave, period);

      // Save on tab close / refresh
      window.addEventListener('beforeunload', handlefinalSave);

      
      return () => {
        clearInterval(intervalRef.current);
        window.removeEventListener('beforeunload', handlefinalSave);
      };
    }, []);

    return {
      manualSave: handleperiodicSave,
      finalSave: handlefinalSave // use this during logout
    };
}
